// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"04e614cf","557":"6b88d711"}[chunkId] + ".chunk.js";
};